var map = {
	"./buttons.json": 121,
	"./buttons@2x.json": 123
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;



//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/buttons.*\.json$
// module id = 184
// module chunks = 3